<template>
  <el-dialog
    width="30%"
    top="25vh"
    :center="true"
    :visible.sync="showDialog"
    append-to-body
    @close="showDialog = false"
  >
    <div slot="title">
      <span class="title">
        <strong>{{nuggetLabel}}:</strong>
        {{nuggetValue}}
      </span>
    </div>
    <div class="controls">
      <el-button
        class="nugget-control"
        size="small"
        type="danger"
        @click="blacklistNugget"
        plain
      >Blacklist for all profiles</el-button>
      <el-button
        class="nugget-control"
        size="small"
        type="danger"
        @click="removeNugget"
        plain
      >Remove from profile</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ProfileNuggetOptionsDialog',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    nuggetKey: {
      type: String,
      default: '',
    },
    nuggetValue: {
      type: String,
      default: '',
    },
    nuggetLabel: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    profileId: {
      type: String,
      required: true,
    },
  },

  computed: {
    showDialog: {
      set() {
        this.$emit('closeDialog');
      },
      get() {
        return this.show;
      },
    },
  },

  methods: {
    removeNugget() {
      this.$confirm(
        `This will remove "${this.nuggetValue}" for the field "${
          this.nuggetLabel
        }" on the current profile. Are you sure you want to continue?`,
        'Remove Value',
      )
        .then(() => {
          this.$emit('removeNugget', {
            value: this.nuggetValue,
            fieldKey: this.nuggetKey,
            category: this.category,
            profileId: this.profileId,
          });
        })
        .catch(() => null);
    },
    blacklistNugget() {
      this.$confirm(
        `This will blacklist "${this.nuggetValue}" for the field "${
          this.nuggetLabel
        }". This applies to all profiles. Are you sure you want to continue?`,
        'Remove Value',
      )
        .then(() => {
          this.$emit('blacklistNugget', {
            text: this.nuggetValue,
            field: this.nuggetKey,
            profileId: this.profileId,
          });
        })
        .catch(() => null);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.5rem;
}

.controls {
  display: flex;
  justify-content: center;
}

.nugget-control {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// ProfileNuggetOptionsDialog.vue?6e1892fe